/**
 * The institute's own charter — vision, mission, quality policy and SWOC — as
 * published at bietdvg.edu/Vision_Mission_Quality_Policies.
 *
 * Vision, mission and the quality-policy points reproduce the institute's own
 * wording, the same way departments.ts carries each department's statements.
 * The SWOC entries are condensed to card-length labels: the source publishes
 * them as a long bulleted list, and the grid they render into (`.swot-grid`)
 * is built for short lines.
 *
 * The institute heads the fourth column "Challenges"; department SWOTs in
 * departments.ts head theirs "Threats". Both are kept as their source has them.
 */

export const VISION =
  "To be a nationally recognized technical institution that empowers engineers to create sustainable, technology-driven solutions through excellence in education, research, and effective leadership.";

export const MISSION: string[] = [
  "To develop competent, ethically grounded, socially responsible engineers through outcome-based and experiential learning.",
  "To foster advanced research, innovation, and emerging technologies that generate sustainable solutions for societal and industrial challenges.",
  "To nurture entrepreneurial mindsets, social innovators, and visionary leaders capable of creating impact on industry, startups, and society.",
  "To establish an industry-integrated, globally connected learning ecosystem for continuous professional development and lifelong learning.",
];

export const QUALITY_POLICY: string[] = [
  "Inculcating the concepts of discipline, punctuality and ethics into the thought process of students to promote their overall growth.",
  "Motivating teachers to impart knowledge through continuous interaction with students.",
  "Carrying out objective evaluation of student performance.",
  "Enhancing the academic skills of the faculty through faculty development programmes.",
  "Creating an atmosphere conducive to research in the campus.",
];

export interface Swoc {
  strengths: string[];
  weaknesses: string[];
  opportunities: string[];
  challenges: string[];
}

export const SWOC: Swoc = {
  strengths: [
    "Visionary, supportive and committed management",
    "Located in central Karnataka",
    "Spacious classrooms, laboratories, seminar halls, hostels and auditorium",
    "State-of-the-art central library",
    "Qualified, experienced faculty across engineering and science",
    "Advanced teaching-learning processes",
    "University-recognised research centres",
    "Strong student performance in examinations",
    "Successful campus placements",
    "Active alumni association",
    "Administrative systems run on ERP",
    "Industry-institute collaboration and consultancy services",
  ],
  weaknesses: [
    "Limited collaborative research with premier organisations",
    "Fewer publications in indexed journals",
    "Fewer research grants and funded projects",
    "Limited patent initiatives",
    "Insufficient full-time research scholars",
  ],
  opportunities: [
    "Obtaining autonomous status",
    "Launching new programmes",
    "Networking with NITs and IITs through MoUs",
    "Expanding government research funding",
    "Establishing skill development and incubation centres",
    "Faculty training on policy changes",
    "Hands-on practical training for students",
    "Enhanced placement and career advancement activities",
  ],
  challenges: [
    "Competition from autonomous and deemed universities",
    "Frequent changes in government policy",
    "Shifts in curriculum and pedagogy",
    "Global economic fluctuations",
    "Declining engineering enrolment trends",
    "Rapid obsolescence of technology",
    "Reduced core-sector employment",
    "Decreasing research interest among students",
    "Multiple compliance requirements",
  ],
};
